import BaseRepository from "./BaseRepository";
import st from "lib/utils/index";
import { serializeOrder, serializeOrderTransfer } from "lib/utils/api/serializers";
import { OrderDecorator, OrderFullDecorator } from "lib/decorators/index";
import { uniqBy } from "lodash";

export default new (class OrdersRepository extends BaseRepository {
  // findAll() {
  //   const bucket = this.getBucket("orders.index")

  //   const existingCollection = bucket.state !== null ? bucket.state : []

  //   const request$ = this.api.get(`/orders`, {
  //     params: {}
  //   })
  //     .map(({ data: { records, all_ids } }) => {
  //       const orders = st.api.dejsonapinize(records.data, records.included)
  //         .map(order => new OrderDecorator(order))
  //       const existingOrders = existingCollection
  //         .filter(order => all_ids.includes(order.id))
  //       return uniqBy(orders.concat(existingOrders), "uuid")
  //     })

  //   return this.mergeRequestWithCurrentBucketState(bucket, request$)
  // }

  search(params = {}) {
    return this.api.post(`/orders/search`, params).map(({ data: { records, aggregations, meta } }) => ({
      records: st.api.dejsonapinize(records.data, records.included).map((order) => new OrderDecorator(order)),
      aggregations,
      meta,
    }));
  }

  find(id, token) {
    return this.api
      .get(`/orders/${id}?token=${token}`)
      .map((response) => st.api.dejsonapinize(response.data.data, response.data.included))
      .map((order) => new OrderFullDecorator(order));
  }

  create(order) {
    const data = {
      ...order,
      order_items: order.order_items.filter((item) => item.item_type === "product_custom"),
    };
    return this.api
      .post(`/orders`, {
        order: serializeOrder(data, undefined, {
          includeSlotAttributes: data.product_schedule_slot && !data.product_schedule_slot.id,
        }),
      })
      .map((response) => st.api.dejsonapinize(response.data.data, response.data.included))
      .map((order) => new OrderFullDecorator(order));
  }

  calculate(order, initialOrder) {
    const token = order.token ? `?token=${order.token}` : "";
    const data = {
      ...order,
      order_items: order.order_items.filter((item) => item.item_type === "product_custom"),
    };

    const serialisedOrder = serializeOrder(data, undefined, {
      includeSlotAttributes: data.product_schedule_slot && !data.product_schedule_slot.id,
    });
    return this.api
      .post(`/orders/calculate`, {
        order: serialisedOrder,
      })
      .map((response) => st.api.dejsonapinize(response.data.order.data, response.data.order.included))
      .map((order) => new OrderFullDecorator(order));
  }

  update(order, initialOrder) {
    const token = order.token ? `?token=${order.token}` : "";
    return this.api
      .put(`/orders/${order.id}${token}`, {
        order: serializeOrder(order, initialOrder),
      })
      .map((response) => st.api.dejsonapinize(response.data.data, response.data.included))
      .map((order) => new OrderFullDecorator(order));
  }

  updateCustomerDetails(order, initialOrder) {
    const token = order.token ? `?token=${order.token}` : "";

    return this.api
      .put(`/orders/${order.id}/customer_details${token}`, {
        order: serializeOrder(order, initialOrder),
      })
      .map((response) => st.api.dejsonapinize(response.data.data, response.data.included))
      .map((order) => new OrderFullDecorator(order));
  }

  updateItems(orderData, initialOrderData) {
    const token = orderData.token ? `?token=${orderData.token}` : "";
    return this.api
      .put(`/orders/${orderData.id}/items${token}`, {
        order: serializeOrder(orderData, initialOrderData),
      })
      .map((response) => st.api.dejsonapinize(response.data.data, response.data.included))
      .map((order) => new OrderFullDecorator(order));
  }

  changeScheduleSlot(order) {
    const token = order.token ? `?token=${order.token}` : "";
    const orderData = {
      product_schedule_slot: order.product_schedule_slot,
    };
    return this.api
      .put(`/orders/${order.id}/change_schedule_slot${token}`, {
        order: serializeOrder(orderData, undefined, {
          includeSlotAttributes: orderData.product_schedule_slot && !orderData.product_schedule_slot.id,
        }),
      })
      .map((response) => st.api.dejsonapinize(response.data.data, response.data.included))
      .map((order) => new OrderFullDecorator(order));
  }

  createOrderTransfer(orderId, orderTransferData) {
    const token = orderTransferData.order_token ? `?token=${orderTransferData.order_token}` : "";
    return this.api
      .post(`/orders/${orderId}/transfers${token}`, {
        order_transfer: serializeOrderTransfer(orderTransferData),
      })
      .map((response) => st.api.dejsonapinize(response.data.data, response.data.included))
      .map((order) => new OrderFullDecorator(order));
  }

  confirm(orderId, orderToken) {
    const token = orderToken ? `?token=${orderToken}` : "";
    return this.api
      .put(`/orders/${orderId}/confirm${token}`)
      .map((response) => st.api.dejsonapinize(response.data.data, response.data.included))
      .map((order) => new OrderFullDecorator(order));
  }

  approve(orderId, orderToken) {
    const token = orderToken ? `?token=${orderToken}` : "";
    return this.api
      .put(`/orders/${orderId}/approve${token}`)
      .map((response) => st.api.dejsonapinize(response.data.data, response.data.included))
      .map((order) => new OrderFullDecorator(order));
  }

  reject(orderId, orderToken) {
    const token = orderToken ? `?token=${orderToken}` : "";
    return this.api
      .put(`/orders/${orderId}/reject${token}`)
      .map((response) => st.api.dejsonapinize(response.data.data, response.data.included))
      .map((order) => new OrderFullDecorator(order));
  }

  finish(orderId, orderToken) {
    const token = orderToken ? `?token=${orderToken}` : "";
    return this.api
      .put(`/orders/${orderId}/finish${token}`)
      .map((response) => st.api.dejsonapinize(response.data.data, response.data.included))
      .map((order) => new OrderFullDecorator(order));
  }

  finishWithOpinionRequest(orderId, orderToken) {
    const token = orderToken ? `?token=${orderToken}` : "";
    return this.api
      .put(`/orders/${orderId}/finish_with_opinion_request${token}`)
      .map((response) => st.api.dejsonapinize(response.data.data, response.data.included))
      .map((order) => new OrderFullDecorator(order));
  }

  cancel(orderId, orderToken) {
    const token = orderToken ? `?token=${orderToken}` : "";
    return this.api
      .put(`/orders/${orderId}/cancel${token}`)
      .map((response) => st.api.dejsonapinize(response.data.data, response.data.included))
      .map((order) => new OrderFullDecorator(order));
  }

  abandon(orderId, orderToken) {
    const token = orderToken ? `?token=${orderToken}` : "";
    return this.api
      .put(`/orders/${orderId}/abandon${token}`)
      .map((response) => st.api.dejsonapinize(response.data.data, response.data.included))
      .map((order) => new OrderFullDecorator(order));
  }

  changeStatus(orderId, orderToken, status, { notifyCustomer = true, notifySupplier = false } = {}) {
    const token = orderToken ? `?token=${orderToken}` : "";
    return this.api
      .put(`/orders/${orderId}/change_status${token}`, {
        status,
        notify_customer: notifyCustomer,
        notify_supplier: notifySupplier,
      })
      .map((response) => st.api.dejsonapinize(response.data.data, response.data.included))
      .map((order) => new OrderFullDecorator(order));
  }

  redeliverCustomerOrderEmail(orderId, orderToken) {
    const token = orderToken ? `?token=${orderToken}` : "";
    return this.api.put(`/orders/${orderId}/redeliver_customer_order_email${token}`);
  }

  redeliverCustomerOrderOpinionReminderEmail(orderId, orderToken) {
    const token = orderToken ? `?token=${orderToken}` : "";
    return this.api.put(`/orders/${orderId}/redeliver_customer_order_opinion_reminder_email${token}`);
  }

  redeliverSupplierOrderEmail(orderId, orderToken) {
    const token = orderToken ? `?token=${orderToken}` : "";
    return this.api.put(`/orders/${orderId}/redeliver_supplier_order_email${token}`);
  }

  delete(id, orderToken) {
    const token = orderToken ? `?token=${orderToken}` : "";
    return this.api.delete(`/orders/${id}${token}`);
  }

  createPlatformDisbursement(ordersIds) {
    return this.api
      .post(`/orders/create_platform_disbursement`, {
        orders_ids: ordersIds,
      })
      .map(
        ({
          data: { order_transfers, collected_order_transfers, orders, skipped_orders_ids, underfunded_orders_ids },
        }) => ({
          order_transfers: st.api.dejsonapinize(order_transfers.data, order_transfers.included),
          collected_order_transfers: st.api.dejsonapinize(
            collected_order_transfers.data,
            collected_order_transfers.included
          ),
          orders: st.api.dejsonapinize(orders.data, orders.included),
          skipped_orders_ids: skipped_orders_ids,
          underfunded_orders_ids: underfunded_orders_ids,
        })
      )
      .map(({ order_transfers, collected_order_transfers, orders, skipped_orders_ids, underfunded_orders_ids }) => ({
        order_transfers,
        collected_order_transfers,
        orders: orders.map((o) => new OrderDecorator(o)),
        skipped_orders_ids,
        underfunded_orders_ids,
      }));
  }

  createAgentDisbursement(ordersIds) {
    return this.api
      .post(`/orders/create_agent_disbursement`, {
        orders_ids: ordersIds,
      })
      .map(({ data: { agent_disbursement, orders } }) => ({
        agent_disbursement: st.api.dejsonapinize(agent_disbursement.data, agent_disbursement.included),
        orders: st.api.dejsonapinize(orders.data, orders.included),
      }))
      .map(({ agent_disbursement, orders }) => ({
        agent_disbursement,
        orders: orders.map((o) => new OrderDecorator(o)),
      }));
  }
})();



// WEBPACK FOOTER //
// ./src/lib/repositories/OrdersRepository.js